import { NavLink } from "react-router-dom";
import { Flex, Box } from "@chakra-ui/react";
import {  CircleGauge, BriefcaseBusiness, Activity, LineChart, ClipboardCheck, } from "lucide-react";

const Navigation = () => {



  

  return (
    <Flex
      position="fixed" 
      bottom={0}
      zIndex={2}
      left={0}
      w={"100%"}
      margin="auto"
      right={0}
      bg='grey.950'
      justifyContent="center"
      px={0}
      py={0}
      sx={{
        "a": {
          color: "grey.300",
          fontSize: "9px",
          fontWeight: "500",
          letterSpacing: "-.02em",
          lineHeight: "1",
          overflow: "hidden",
          textOverflow: "ellipsis",
          textTransform: "capitalize",
          whiteSpace: "nowrap",
          display: "flex",
          flex: 1,
          maxWidth: "80px",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          px: 4,
          pt:4,
          pb:6,
          borderTop: "3px solid",
          borderColor: "transparent",
        },
        "a > div": {
          borderRadius: 8,
          p: 2,
        },
        "a:hover > div": {
          bg: "rgba(255, 255, 255, 0.05)",
        },
        "a.active > div": {
          bg: "brand.700",
        },
        "a .lucide": {
          color: "grey.300",
        },
        "a.active": {
          color: "white",
          borderTop: "3px solid",
          borderColor: "brand.700",
        },
        "a.active .lucide": {
          color: "white",
        },
      }}
      >
      
  

              <NavLink to={`/`} end>
                  <Box><CircleGauge size={20} /></Box>
                  <span>Dashboard</span>
              </NavLink>
              <NavLink to={`/funds/active`} end>
                  <Box><BriefcaseBusiness size={20} /></Box>
                  <span>Funds</span>
              </NavLink>
              <NavLink to={`/tasks/pending`} end>
                  <Box><ClipboardCheck size={20} /></Box>
                  <span>Tasks</span>
              </NavLink>
              <NavLink to={`/monitoring/documents`} end>
                  <Box><Activity size={20} /></Box>
                  <span>Monitoring</span>
              </NavLink>
              <NavLink to={`/reporting/overview`} end>
                <Box><LineChart size={20} /></Box>
                  <span>Reporting</span>
              </NavLink>
              

         
          

         

     
          

      
     

   
    </Flex>
  );
};

export default Navigation;
